import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import DoctorSidebar from "../sidebar/DoctorSidebar";

const DoctorLayout = () => {
  const location = useLocation();
  const authPaths = [
    "/doctor/login",
    "/doctor/signup",
    "/doctor/verify-otp",
    "/doctor/forgot-password/email",
    "/doctor/forgot-password/verify",
    "/doctor/forgot-password/create-password",
    "/doctor/information",
    "/doctor/profileUnderReview",
  ];
  const shouldShowNavbar = !authPaths.includes(location.pathname);

  return (
    <div className="min-h-screen">
      {shouldShowNavbar && <DoctorSidebar />}
      <div className={`flex flex-col ${shouldShowNavbar ? "ml-64" : ""}`}>
        {shouldShowNavbar && <Navbar />}
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="p-4 flex-grow"
          >
            <Outlet />
          </motion.main>
        </AnimatePresence>
      </div>
    </div>
    // <div className="flex flex-1 h-screen w-screen overflow-hidden ">
    //   {shouldShowNavbar && <DoctorSidebar />}
    //   <div
    //     className={`flex flex-1 flex-col overflow-hidden  ${shouldShowNavbar ? "ml-64" : ""}`}
    //   >
    //     {shouldShowNavbar && <Navbar />}
    //     <div className="flex flex-1 ">
    //       <AnimatePresence mode="wait">
    //         <motion.main
    //           key={location.pathname}
    //           initial={{ opacity: 0, y: 20 }}
    //           animate={{ opacity: 1, y: 0 }}
    //           exit={{ opacity: 0, y: -20 }}
    //           transition={{ duration: 0.3 }}
    //           className="p-4 flex-1 flex flex-col min-h-0"
    //         >
    //           <div className="flex flex-1 overflow-hidden min-h-0">
    //             <Outlet />
    //           </div>
    //         </motion.main>
    //       </AnimatePresence>
    //     </div>
    //   </div>
    // </div>
  );
};
//crearted new component for doctor layout to give children flex-1 overflow-hidden but it is not working due to children are controlled by parent
//  <div className="flex flex-1 h-screen w-screen overflow-hidden ">
//    {shouldShowNavbar && <DoctorSidebar />}
//    <div
//      className={`flex flex-1 flex-col overflow-hidden  ${shouldShowNavbar ? "ml-64" : ""}`}
//    >
//      {shouldShowNavbar && <Navbar />}
//      <div className="flex flex-1 ">
//        <AnimatePresence mode="wait">
//          <motion.main
//            key={location.pathname}
//            initial={{ opacity: 0, y: 20 }}
//            animate={{ opacity: 1, y: 0 }}
//            exit={{ opacity: 0, y: -20 }}
//            transition={{ duration: 0.3 }}
//            className="p-4 flex-1 flex flex-col min-h-0"
//          >
//            <div className="flex flex-1 overflow-hidden min-h-0">
//              <Outlet />
//            </div>
//          </motion.main>
//        </AnimatePresence>
//      </div>
//    </div>
//  </div>;
export default DoctorLayout;
